import { render, staticRenderFns } from "./ServiceNicheIcon.vue?vue&type=template&id=095b1642&scoped=true"
import script from "./ServiceNicheIcon.vue?vue&type=script&lang=js"
export * from "./ServiceNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095b1642",
  null
  
)

export default component.exports